import styled from "styled-components";
import { Box } from "@mui/material";

const INK = "#14202b";
const PEACH = "#fdad73";
const PEACH_DEEP = "#fd944d";
const BLUSH = "#FFE3E3";

export const WhoAreWeSection = styled(Box)`
	padding: 88px 0 0;
	font-family: var(--poppins), "Poppins", sans-serif;
	color: ${INK};
	overflow-x: clip;

	h1,
	p {
		margin: 0;
	}

	.who_are_we_wrapper {
		margin-top: 48px;
		display: grid;
		grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);
		gap: clamp(32px, 6vw, 88px);
		align-items: center;
	}

	.mission {
		font-size: clamp(22px, 2.6vw, 32px);
		line-height: 1.45;
		font-weight: 600;
		letter-spacing: -0.02em;
		color: ${INK};
		max-width: 28em;
	}

	.closing {
		margin-top: 32px;
		padding-left: 20px;
		border-left: 4px solid transparent;
		border-image: linear-gradient(180deg, ${PEACH}, ${PEACH_DEEP}) 1;
		font-size: clamp(16px, 1.5vw, 18px);
		line-height: 1.75;
		color: ${({ theme }) => theme.palette.text.secondary};
		max-width: 46ch;
	}

	.illustration {
		box-sizing: border-box;
		display: grid;
		place-items: center;
		aspect-ratio: 1 / 1;
		padding: clamp(24px, 5vw, 56px);
		border-radius: 40px;
		background:
			radial-gradient(70% 60% at 30% 25%, rgba(255, 255, 255, 0.9), transparent 70%),
			linear-gradient(145deg, ${BLUSH} 0%, #dbe7f1 100%);
		box-shadow:
			inset 0 0 0 1px rgba(120, 157, 188, 0.2),
			0 40px 80px rgba(47, 75, 99, 0.12);
		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	${props => props.theme.breakpoints.down("md")} {
		padding-top: 80px;
		.who_are_we_wrapper {
			grid-template-columns: minmax(0, 1fr);
			margin-top: 32px;
		}
		.illustration {
			aspect-ratio: 4 / 3;
			border-radius: 28px;
			max-width: 520px;
			width: 100%;
			margin: 0 auto;
		}
	}
`;
